module.exports = __webpack_public_path__ + "img/MottoCenter-D-TOOLS-Website.da035ee8.png";